import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  getReports,
  getFailedLogs,
  downloadReport,
  getpos,
  getStage1BatchesApi,
  getOtherReportPdf,
  getOtherReportCsv,
  getMaterialBatches,
  getBinSeriesList,
  getMaterialReceiptAuditTrail,
  getMaterialReceiptAuditTrailPdf,
  getMaterialReceiptAuditCandidates,
  getMaterialReceiptRangeCandidates,
  getMaterialReceiptCombinedPdf,
  getWipLabelCandidates,
  getWipLabelTimeline,
  getWipLabelPdf,
  getMscLabelCandidates,
  getMscLabelTimeline,
  getMscLabelPdf,
  getMoveMaterialAuditCandidates,
  getMoveMaterialAuditTrail,
  getMoveMaterialAuditTrailPdf,
  getMrrAuditCandidates,
  getMrrAuditTrail,
  getMrrAuditTrailPdf,
  getLcMatVerCandidates,
  getLcMatVerTimeline,
  getLcMatVerPdf,
  getProdVerCandidates,
  getProdVerTimeline,
  getProdVerPdf
} from './api';

const initialState = {
  loading: false
};

const actions = {
  GET_REPORTS: 'audit/GET_REPORTS',
  GET_FAILED_LOGINS: 'audit/GET_FAILED_LOGINS',
  DOWNLOAD_AUDIT: 'audit/DOWNLOAD_AUDIT',
  GET_PO_NUMBERS: 'audit/GET_PO_NUMBERS',
  GET_STAGE1_BATCHES: 'audit/GET_STAGE1_BATCHES',
  DOWNLOAD_OTHER_REPORT_PDF: 'audit/DOWNLOAD_OTHER_REPORT_PDF',
  DOWNLOAD_OTHER_REPORT_CSV: 'audit/DOWNLOAD_OTHER_REPORT_CSV',
  GET_MATERIAL_BATCHES: 'audit/GET_MATERIAL_BATCHES',
  GET_BIN_SERIES: 'audit/GET_BIN_SERIES',
  GET_MATERIAL_RECEIPT_AUDIT: 'audit/GET_MATERIAL_RECEIPT_AUDIT',
  GET_MATERIAL_RECEIPT_AUDIT_PDF: 'audit/GET_MATERIAL_RECEIPT_AUDIT_PDF',
  GET_MATERIAL_RECEIPT_AUDIT_CANDIDATES:
    'audit/GET_MATERIAL_RECEIPT_AUDIT_CANDIDATES',
  GET_MATERIAL_RECEIPT_RANGE_CANDIDATES:
    'audit/GET_MATERIAL_RECEIPT_RANGE_CANDIDATES',
  GET_MATERIAL_RECEIPT_COMBINED_PDF: 'audit/GET_MATERIAL_RECEIPT_COMBINED_PDF',
  GET_WIP_LABEL_CANDIDATES: 'audit/GET_WIP_LABEL_CANDIDATES',
  GET_WIP_LABEL_TIMELINE: 'audit/GET_WIP_LABEL_TIMELINE',
  GET_WIP_LABEL_PDF: 'audit/GET_WIP_LABEL_PDF',
  GET_MSC_LABEL_CANDIDATES: 'audit/GET_MSC_LABEL_CANDIDATES',
  GET_MSC_LABEL_TIMELINE: 'audit/GET_MSC_LABEL_TIMELINE',
  GET_MSC_LABEL_PDF: 'audit/GET_MSC_LABEL_PDF',
  GET_MOVE_MATERIAL_AUDIT_CANDIDATES:
    'audit/GET_MOVE_MATERIAL_AUDIT_CANDIDATES',
  GET_MOVE_MATERIAL_AUDIT: 'audit/GET_MOVE_MATERIAL_AUDIT',
  GET_MOVE_MATERIAL_AUDIT_PDF: 'audit/GET_MOVE_MATERIAL_AUDIT_PDF',
  GET_MRR_AUDIT_CANDIDATES: 'audit/GET_MRR_AUDIT_CANDIDATES',
  GET_MRR_AUDIT: 'audit/GET_MRR_AUDIT',
  GET_MRR_AUDIT_PDF: 'audit/GET_MRR_AUDIT_PDF',
  GET_LC_MATVER_CANDIDATES: 'audit/GET_LC_MATVER_CANDIDATES',
  GET_LC_MATVER_TIMELINE: 'audit/GET_LC_MATVER_TIMELINE',
  GET_LC_MATVER_PDF: 'audit/GET_LC_MATVER_PDF',
  GET_PRODVER_CANDIDATES: 'audit/GET_PRODVER_CANDIDATES',
  GET_PRODVER_TIMELINE: 'audit/GET_PRODVER_TIMELINE',
  GET_PRODVER_PDF: 'audit/GET_PRODVER_PDF'
};

export const getAllReports = createAsyncThunk(
  actions.GET_REPORTS,
  async (payload) => {
    const response = await getReports('audit_log_view', payload);
    return response;
  }
);

export const getFailedLoginReports = createAsyncThunk(
  actions.GET_FAILED_LOGINS,
  async (payload) => {
    const response = await getFailedLogs('failed-logins', payload);
    return response;
  }
);

export const DownloadAuditReport = createAsyncThunk(
  actions.DOWNLOAD_AUDIT,
  async (payload) => {
    const response = await downloadReport('audit_log_download', payload);
    return response;
  }
);

export const getPoNumbers = createAsyncThunk(
  actions.GET_PO_NUMBERS,
  async (payload) => {
    const response = await getpos('search_po_no_invoice_no', payload);
    return response;
  }
);

export const getStage1Batches = createAsyncThunk(
  actions.GET_STAGE1_BATCHES,
  async (payload) => {
    const response = await getStage1BatchesApi('stage1-batches', payload);
    return response;
  }
);

export const downloadOtherReportPdf = createAsyncThunk(
  actions.DOWNLOAD_OTHER_REPORT_PDF,
  async (payload) => {
    const response = await getOtherReportPdf(payload);
    return response;
  }
);

export const downloadOtherReportCsv = createAsyncThunk(
  actions.DOWNLOAD_OTHER_REPORT_CSV,
  async (payload) => {
    const response = await getOtherReportCsv(payload);
    return response;
  }
);

export const fetchMaterialBatches = createAsyncThunk(
  actions.GET_MATERIAL_BATCHES,
  async (payload) => {
    const response = await getMaterialBatches(payload);
    return response;
  }
);

export const fetchBinSeries = createAsyncThunk(
  actions.GET_BIN_SERIES,
  async () => {
    const response = await getBinSeriesList();
    return response;
  }
);

export const fetchMaterialReceiptAuditTrail = createAsyncThunk(
  actions.GET_MATERIAL_RECEIPT_AUDIT,
  async (payload) => {
    const response = await getMaterialReceiptAuditTrail(payload);
    return response;
  }
);

export const downloadMaterialReceiptAuditPdf = createAsyncThunk(
  actions.GET_MATERIAL_RECEIPT_AUDIT_PDF,
  async (payload) => {
    const response = await getMaterialReceiptAuditTrailPdf(payload);
    return response;
  }
);

export const fetchMaterialReceiptAuditCandidates = createAsyncThunk(
  actions.GET_MATERIAL_RECEIPT_AUDIT_CANDIDATES,
  async (payload) => {
    const response = await getMaterialReceiptAuditCandidates(payload);
    return response;
  }
);

export const fetchMaterialReceiptRangeCandidates = createAsyncThunk(
  actions.GET_MATERIAL_RECEIPT_RANGE_CANDIDATES,
  async (payload) => {
    const response = await getMaterialReceiptRangeCandidates(payload);
    return response;
  }
);

export const downloadMaterialReceiptCombinedPdf = createAsyncThunk(
  actions.GET_MATERIAL_RECEIPT_COMBINED_PDF,
  async (payload) => {
    const response = await getMaterialReceiptCombinedPdf(payload);
    return response;
  }
);

// WIP Label Audit Trail thunks (2026-05-18)
export const fetchWipLabelCandidates = createAsyncThunk(
  actions.GET_WIP_LABEL_CANDIDATES,
  async (payload) => {
    const response = await getWipLabelCandidates(payload);
    return response;
  }
);

export const fetchWipLabelTimeline = createAsyncThunk(
  actions.GET_WIP_LABEL_TIMELINE,
  async (payload) => {
    const response = await getWipLabelTimeline(payload);
    return response;
  }
);

export const downloadWipLabelPdf = createAsyncThunk(
  actions.GET_WIP_LABEL_PDF,
  async (payload) => {
    const response = await getWipLabelPdf(payload);
    return response;
  }
);

export const fetchMscLabelCandidates = createAsyncThunk(
  actions.GET_MSC_LABEL_CANDIDATES,
  async (payload) => {
    const response = await getMscLabelCandidates(payload);
    return response;
  }
);

export const fetchMscLabelTimeline = createAsyncThunk(
  actions.GET_MSC_LABEL_TIMELINE,
  async (payload) => {
    const response = await getMscLabelTimeline(payload);
    return response;
  }
);

export const downloadMscLabelPdf = createAsyncThunk(
  actions.GET_MSC_LABEL_PDF,
  async (payload) => {
    const response = await getMscLabelPdf(payload);
    return response;
  }
);

// Move Material Audit Trail thunks (2026-05-19)
export const fetchMoveMaterialAuditCandidates = createAsyncThunk(
  actions.GET_MOVE_MATERIAL_AUDIT_CANDIDATES,
  async (payload) => {
    const response = await getMoveMaterialAuditCandidates(payload);
    return response;
  }
);

export const fetchMoveMaterialAuditTrail = createAsyncThunk(
  actions.GET_MOVE_MATERIAL_AUDIT,
  async (payload) => {
    const response = await getMoveMaterialAuditTrail(payload);
    return response;
  }
);

export const downloadMoveMaterialAuditPdf = createAsyncThunk(
  actions.GET_MOVE_MATERIAL_AUDIT_PDF,
  async (payload) => {
    const response = await getMoveMaterialAuditTrailPdf(payload);
    return response;
  }
);

// MRR Audit Trail thunks (2026-05-20)
export const fetchMrrAuditCandidates = createAsyncThunk(
  actions.GET_MRR_AUDIT_CANDIDATES,
  async (payload) => {
    const response = await getMrrAuditCandidates(payload);
    return response;
  }
);

export const fetchMrrAuditTrail = createAsyncThunk(
  actions.GET_MRR_AUDIT,
  async (payload) => {
    const response = await getMrrAuditTrail(payload);
    return response;
  }
);

export const downloadMrrAuditPdf = createAsyncThunk(
  actions.GET_MRR_AUDIT_PDF,
  async (payload) => {
    const response = await getMrrAuditTrailPdf(payload);
    return response;
  }
);

// Line Clearance — Material Verification Audit Trail thunks (2026-06-12)
export const fetchLcMatVerCandidates = createAsyncThunk(
  actions.GET_LC_MATVER_CANDIDATES,
  async (payload) => {
    const response = await getLcMatVerCandidates(payload);
    return response;
  }
);

export const fetchLcMatVerTimeline = createAsyncThunk(
  actions.GET_LC_MATVER_TIMELINE,
  async (payload) => {
    const response = await getLcMatVerTimeline(payload);
    return response;
  }
);

export const downloadLcMatVerPdf = createAsyncThunk(
  actions.GET_LC_MATVER_PDF,
  async (payload) => {
    const response = await getLcMatVerPdf(payload);
    return response;
  }
);

// Product Verification Audit Trail thunks (2026-06-12)
export const fetchProdVerCandidates = createAsyncThunk(
  actions.GET_PRODVER_CANDIDATES,
  async (payload) => {
    const response = await getProdVerCandidates(payload);
    return response;
  }
);

export const fetchProdVerTimeline = createAsyncThunk(
  actions.GET_PRODVER_TIMELINE,
  async (payload) => {
    const response = await getProdVerTimeline(payload);
    return response;
  }
);

export const downloadProdVerPdf = createAsyncThunk(
  actions.GET_PRODVER_PDF,
  async (payload) => {
    const response = await getProdVerPdf(payload);
    return response;
  }
);

export const AuditTrailsSlice = createSlice({
  name: 'AuditTrail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllReports.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(getAllReports.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getAllReports.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });

    builder
      .addCase(getFailedLoginReports.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(getFailedLoginReports.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getFailedLoginReports.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });

    builder
      .addCase(DownloadAuditReport.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(DownloadAuditReport.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(DownloadAuditReport.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getPoNumbers.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(getPoNumbers.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getPoNumbers.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });
  }
});

export default AuditTrailsSlice.reducer;
